// extracted by mini-css-extract-plugin
export var label = "_by-5";
export var slideContainer = "_by-0";
export var slider = "_by-1";
export var sliderLg = "_by-4";
export var sliderMd = "_by-3";
export var sliderSm = "_by-2";